<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div class="card-title d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-start align-items-center">
          <button
            type="button"
            class="btn btn-icon btn-outline-primary"
            rippleEffect
            (click)="Back()"
          >
            <span [data-feather]="'arrow-left'"></span>
          </button>            
          <span class="pl-2">Facturas del envío {{noShipment}}</span>

          <span class="pl-2"><button class="btn btn-link" type="button" (click)="collapse.toggle()"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="collapseExample">
          Click para mostrar resumen por estados
        </button></span>
        </div>         
        
        <div>
          
        </div>    
        </div>
        <div class="card-title d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-start align-items-center">
            <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
              <div class="card">
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let item of states" [selectable]="selectable"
                           >
                           <span class="chip-header">{{item.status}}</span><span class="chip-text pl-1 text-nowrap">{{item.count}}</span>
                    
                  </mat-chip>                                        
                </mat-chip-list>
              </div>
            </div>
          </div> 
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">Mostrando
                  <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option *ngIf="bills.length > 15" [value]="bills.length">Todos</option>
                  </select>
                  envíos</label>
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                <label class="d-flex align-items-center">Buscar</label><input #searchInput type="search" (keyup)="FilterUpdate(searchInput.value)"
                  (search)="FilterUpdate(searchInput.value)"
                    class="form-control ml-25 mb-1" 
                     />
                     <button class="btn btn-success align-items-center ml-1 mb-1" type="button" (click)="export()" [disabled]="!bills?.length">
                      <em class="fa fa-print"></em>
                    </button>
              </div>
            </div>
          </div>
          <ngx-datatable #table ngx-resize-watcher [rows]="bills" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de envíos'}">
                        <ngx-datatable-column name="Código" prop="billCode">
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Peso" prop="billPounds">
                          <ng-template let-bill="value" ngx-datatable-cell-template>
                            {{ bill | number: '1.2-2'}}
                        </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Provincia" prop="province">
                            <ng-template let-province="value" ngx-datatable-cell-template>
                                {{ province }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Municipio" prop="municipality">
                            <ng-template let-municipality="value" ngx-datatable-cell-template>
                                {{ municipality }}
                            </ng-template>
                        </ngx-datatable-column>                        
                        <ngx-datatable-column name="Estado" prop="status">
                            <ng-template let-status="value" ngx-datatable-cell-template>
                                <div class="badge badge-pill badge-light-primary">
                                    {{ status }}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>   
                        <ngx-datatable-footer *ngIf="true">
                          <ng-template
                            ngx-datatable-footer-template
                            let-rowCount="rowCount"
                            let-pageSize="pageSize"
                            let-selectedCount="selectedCount"
                            let-curPage="curPage"
                            let-offset="offset"
                          >
                          <div class="d-flex justify-content-between w-100">
                            <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                              <div>Total facturas: {{ rowCount }} | Total libras: {{ totalPounds() | number :'1.2-2' }}</div>
                            </div>
                            <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                                <datatable-pager
                                [pagerLeftArrowIcon]="'datatable-icon-left'"
                                [pagerRightArrowIcon]="'datatable-icon-right'"
                                [pagerPreviousIcon]="'datatable-icon-prev'"
                                [pagerNextIcon]="'datatable-icon-skip'"
                                [page]="curPage"
                        [visiblePagesCount]="currentVisible"
                        [size]="pageSize"
                        [count]="rowCount"
                        [hidden]="!((rowCount / pageSize) > 1)"
                        (change)="table.onFooterPage($event)">                
                            </datatable-pager>
                              </div>
                          </div>
                          
                          
                            
                            
                          </ng-template>
                        </ngx-datatable-footer>                     
                    </ngx-datatable>
        </div>
      </div>
                  
